import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./CompanyCreate.module.sass";
import { Link } from "react-router-dom";
import Icon from "../../components/Icon";

// Screens
import SearchCompany from "./searchCompany";
import CompanyInformations from "./CompanyInformations";
import AddressInformations from "./AddressInformations";
import DirectorInformations from "./DirectorInformations";


// Services
import { createCompany } from "../../services/company.service";
import { showSuccess, showError } from "../../services/toast.service";
import ContactInformations from "./ContactInformations";

const CompanyCreate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [companyData, setCompanyData] = useState({});

  const handleCompanyChange = (e) => {
    const { name, value } = e.target;
    setCompanyData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSwitchChange = (name, value) => {
    setCompanyData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, value) => {
    // Extraire uniquement la valeur du dropdown si c'est un objet avec une propriété value
    let finalValue = value && typeof value === 'object' && value.value !== undefined ? value.value : value;
    
    // Convertir en nombre si c'est une valeur numérique (pour type_of_employer et specific_employer)
    if ((name === 'type_of_employer' || name === 'specific_employer') && !isNaN(Number(finalValue))) {
      finalValue = Number(finalValue);
    }
    setCompanyData((prev) => ({ ...prev, [name]: finalValue }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      await createCompany(companyData);
      showSuccess("Entreprise créée avec succès!");
      navigate("/admin/companies/");
    } catch (err) {
      const errorMessage =
        "Impossible de créer l'entreprise: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <Link className={cn("button-white", styles.button)} to="/admin/companies/">
          <Icon name="arrow-left" />
          Retour
        </Link>

        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>

        <div className={styles.formContainer}>
          {error && <div className={styles.error}>{error}</div>}
          
          <form onSubmit={handleSubmit}>
            <SearchCompany
              company={companyData}
              onCompanyChange={handleCompanyChange}
            />
            <CompanyInformations
              company={companyData}
              onCompanyChange={handleCompanyChange}
              onDropdownChange={handleDropdownChange}
              onSwitchChange={handleSwitchChange}
            />
            <AddressInformations
              company={companyData}
              onCompanyChange={handleCompanyChange}
            />
            <ContactInformations
              company={companyData}
              onCompanyChange={handleCompanyChange}
            />
            <DirectorInformations
              company={companyData}
              onCompanyChange={handleCompanyChange}
              onDropdownChange={handleDropdownChange}
              loading={loading}
            />
           
          </form>
        </div>
      </div>
    </>
  );
};

export default CompanyCreate;
